import ApiService from '@/common/api.service';

export const FaqTagService = {
    get() {
        return ApiService.get('/faq/tags')
    }
};
